import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SilkService {
  getSilkImageUrl(entryColourCode: string, colourDescription: string): string {
    return `${environment.silkBase}?id=${entryColourCode}&desc=${colourDescription}`;
  }
}
